export default ({ request }) => ({
    ecomAmzSkuReportNoShipRecordApi(data = {}) {
        return request({
            url: '/ecom/amz/sku/report/noShipRecord',
            method: 'POST',
            data,
            timeout: 60000,
        })
    },
    ecomAmzSkuReportNoShipRecordTotalApi(data = {}) {
        return request({
            url: '/ecom/amz/sku/report/noShipRecord/total',
            method: 'POST',
            data,
            timeout: 60000,
        })
    },
})
